import React, { useMemo, useState } from "react";
import "./LedgerEntry.css";
import { toast } from "react-toastify";

const LedgerEntry = () => {
      const [searchQuery, setSearchQuery] = useState("");
      const [currentPage, setCurrentPage] = useState(1);
      const [itemsPerPage, setItemsPerPage] = useState(1);
      const ITEMS_PER_PAGE_OPTIONS = [1, 2, 4];
  const [formData, setFormData] = useState({
    ledger: "",
    date: "",
    amount: "",
    factor: "",
    voucherType: "",
    paymentType: "",
    narration: "",
  });

  const [entries, setEntries] = useState([
     {
      id: 1,
      ledger: "Cash in Hand",
      date: "20-1-2025",
      amount: "5000",
      factor: "CR",
      voucherType: "journal",
      paymentType: "Cash",
      narration: "hello",
    },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.ledger || !formData.amount || !formData.date) {
      toast.warn("Please fill required fields");
      return;
    }

    setEntries((prev) => [
      ...prev,
      { ...formData, id: prev.length + 1, status: "Approved" },
    ]);

    setFormData({
      ledger: "",
      date: "",
      amount: "",
      factor: "",
      voucherType: "",
      paymentType: "",
      narration: "",
    });
  };

    // Search + Pagination
    const filteredData = useMemo(() => {
      return entries.filter((item) =>
        Object.values(item).join(" ").toLowerCase().includes(searchQuery.toLowerCase())
      );
    }, [entries, searchQuery]);
  
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  
    const paginatedData = filteredData.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  
    const handleItemsPerPageChange = (e) => {
      setItemsPerPage(Number(e.target.value));
      setCurrentPage(1);
    };
  return (
    <div className="ledgerEntry-container">
      <h1 className="ledgerEntry-heading">Ledger Entry</h1>

      {/* ================= FORM ================= */}
      <section className="ledgerEntry-top">
        <form className="ledgerEntry-form" onSubmit={handleSubmit}>
          <div className="ledgerEntry-form-section">
            <div className="ledgerEntry-form-input-fields">
              <label>Select Ledger</label>
              <select name="ledger" value={formData.ledger} onChange={handleChange}>
                <option value="">Select Ledger</option>
                <option value="Cash in Hand">Cash in Hand</option>
                <option value="Bank">Bank</option>
              </select>
            </div>

            <div className="ledgerEntry-form-input-fields">
              <label>Select Date</label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
              />
            </div>

            <div className="ledgerEntry-form-input-fields">
              <label>Amount</label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
              />
            </div>

            <div className="ledgerEntry-form-input-fields">
              <label>Factor</label>
              <select name="factor" value={formData.factor} onChange={handleChange}>
                <option value="">Select Factor</option>
                <option value="CR">CR</option>
                <option value="DR">DR</option>
              </select>
            </div>

            <div className="ledgerEntry-form-input-fields">
              <label>Voucher Type</label>
              <select
                name="voucherType"
                value={formData.voucherType}
                onChange={handleChange}
              >
                <option value="">Select Voucher Type</option>
                <option value="Journal">Journal</option>
                <option value="Receipt">Receipt</option>
              </select>
            </div>

            <div className="ledgerEntry-form-input-fields">
              <label>Payment Type</label>
              <select
                name="paymentType"
                value={formData.paymentType}
                onChange={handleChange}
              >
                <option value="">Select Payment Type</option>
                <option value="Cash">Cash</option>
                <option value="Online">Online</option>
              </select>
            </div>
          </div>

          <div className="ledgerEntry-narration-input">
            <label>Narration</label>
            <textarea
              name="narration"
              value={formData.narration}
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="ledgerEntry-form-submit-btn">
            <button type="submit">Add</button>
          </div>
        </form>
      </section>


      {/* ================= REPORT SECTION ================= */}
        <div className="ledgerEntry-report-container">
           <h1>Ledger Entry Report</h1>
          <div className="ledgerEntry-report-filter-div">
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            <div className="ledgerEntry-filter">
              <label>Show </label>
              <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
                {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                  <option key={num} value={num}>{num}</option>
                ))}
              </select>
              <span> entries</span>
            </div>
            
          </div>

          <div className="ledgerEntry-report-table-container">
            <table className="ledgerEntry-report-table">
              <thead>
                <tr>
                   <th>SN.</th>
                <th>Ledger</th>
                <th>Voucher Type</th>
                <th>Payment Type</th>
                <th>Narration</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Factor</th>
                <th>Date</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{item.ledger}</td>
                    <td>{item.voucherType}</td>
                    <td>{item.paymentType}</td>
                    <td>{item.narration}</td>
                    <td>{item.amount}</td>
                    <td>{item.status}</td>
                    <td>{item.factor}</td>
                    <td>{item.date}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" style={{ textAlign: "center" }}>No results found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {filteredData.length > itemsPerPage && (
            <div className="ledgerEntry-pagination-div">
              <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
                ⬅ Prev
              </button>

              <span> Page {currentPage} of {totalPages} </span>

              <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
                Next ➡
              </button>
            </div>
          )}
      </div>
    </div>
  );
};

export default LedgerEntry;
